<template>
    <div class="">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">LISTADO DE MOVIMIENTOS DE BODEGAS</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <modal-ayuda></modal-ayuda>
        </v-card>
        <v-card>
            <tabla-paginada class="filitas" @cargar="cargar($event)" @editar="editar($event)" @detalle="detalle($event)" @editar_movimiento="editar_movimiento($event)"></tabla-paginada>
        </v-card>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
import TablaPaginada from '@/components/shared/TablaPaginada.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        lista:[],
        motivos:[],
        movimientos:[],
        tipo_movimientos:[],
        bodegas:[],
        proviene_de:[],
        can_download: true,
        inputs:[],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:'',
            motivos_repaso:[]
        },
        columnas:[
            {nombre:'N°', width:'6%', align:'center', tipo:'numero', path:'id', key:'id', searchable:true, busqueda:''},
            {nombre:'Fecha', width:'10%', align: 'center',tipo: 'date',opciones:[],path: 'fecha',key:'fecha',searchable:true,busqueda:''},
            {nombre:'Guia Despacho', width:'8%', align:'center',tipo: 'numero',path: 'nro_guia',key:'guia',searchable:true,busqueda:''},
            {nombre:'Tipo Movimiento', width:'8%', align:'center',tipo: 'select',path: 'tipo_movimiento_texto',key:'tipo_movimiento',searchable:true,busqueda:'',opciones:[],valor_opcion:'valor',texto_opcion:'texto'},
            {nombre:'Motivo Movimiento', width:'10%', align:'center',tipo: 'select',path: 'motivo_movimiento_texto',key:'motivo_movimiento',searchable:true,busqueda:'',opciones:[],valor_opcion:'valor',texto_opcion:'texto'},
            {nombre:'Bodega Origen', width:'20%', align:'center',tipo: 'select',path: 'bodega_origen_texto',key:'bodega_origen',searchable:true,busqueda:'',opciones:[],valor_opcion:'id',texto_opcion:'nombre'},
            {nombre:'Bodega Destino', width:'20%', align:'center',tipo: 'select',path: 'bodega_destino_texto',key:'bodega_destino',searchable:true,busqueda:'',opciones:[],valor_opcion:'id',texto_opcion:'nombre'},
            {nombre:'Recepción', width:'5%',key:'detalle',tipo:'evento',color:'#1565C0',icono:'find_in_page',evento:'detalle',searchable:false},
            {nombre:'Detalle', width:'5%',key:'detalle',tipo:'evento',color:'#1565C0',icono:'zoom_in',evento:'detalle',searchable:false},
            {nombre:'Editar', width:'8%',key:'editar_movimiento',tipo:'evento',color:'#15C065',icono:'edit',evento:'editar_movimiento',searchable:false},
        ],
        acciones:[
        ]
    }),
    created() {
    },
    beforeDestroy() {
        Event.$off('actualizar_tabla');
    },
    mounted() {
        this.cargarTipoMovimientos();
        this.cargarMotivos();
        this.cargarBodegas();
        this.cargar('');
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Listado de Movimientos`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se muestra el listado de Movimientos de maxisacos (Ingresos y Salidas) que se han registrado en el sistema de producción. Las columnas que se muestran son:`},
                        {   tipo:`label`,   texto:`- Número del movimiento, Fecha, Nro de Guía, Tipo (Ingreso o Salida), Motivo (Traslado, Reproceso, Reensaque, Venta), Bodega Origen, Bodega Destino`},
                        {   tipo:`label`,   texto:`- Detalle : Al hacer click en la lupita de cada fila, se muestra el detalle del movimiento (lotes y maxisacos asociados al movimiento) con la opción de exportarlo a Excel. También se puede eliminar un maxisaco desde esa pantalla de detalle `},
                        {   tipo:`label`,   texto:`- Editar : Al hacer click en el botón de editar de cada fila, se abre una pantalla para poder modificar el movimiento `},
                        {   tipo:`imgtexto`,  url:`help-lista-movs.png`, ratio:'7.4', cols:'3', texto:`Bajo la fila de títulos tenemos la opción de filtrar información, o realizar búsquedas por número de movimiento, fecha, guía, tipo o motivo del movimiento, bodega origen o destino.`},
                        {   tipo:`imgtexto`,  url:`help-paginacion.png`, ratio:'7.4', cols:'1', texto:`- Finalmente, en la parte inferior de la pantalla se encuentra la paginación para ir a los registros mas antiguos o más recientes (hacer clic en los números)... `},

                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarTipoMovimientos(){
            this.mostrarLoading({titulo:'Cargando Tipo Movimientos...',color:'green'})
            let url = `${this.base_url}movimiento/tipos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.tipo_movimientos = response.data.data;
                this.columnas[3].opciones = this.tipo_movimientos;
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar Tipos de Movimientos..");
            });
            this.ocultarLoading();

        },
        async cargarMotivos(){
            this.mostrarLoading({titulo:'Cargando Motivos Movimientos...',color:'green'})
            await this.axios.get(`${this.base_url}movimiento/motivos`,this.headers).then((res)=>{
                this.motivos = res.data.data;
                this.columnas[4].opciones = this.motivos;
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar Motivos de Movimientos..");
            });
            this.ocultarLoading();

        },
        async cargarBodegas(){
            this.mostrarLoading({titulo:'Cargando Bodegas...',color:'green'})
            let url = `${this.base_url}get_bodegas`;
            this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                this.columnas[5].opciones = this.bodegas;
                this.columnas[6].opciones = this.bodegas;
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar Bodegas..");
            });
            this.ocultarLoading();
        },
        async cargar(query){
            //this.mostrarLoading({titulo:'Cargando Movimientos...',color:'green'})
            await this.axios.get(`${this.base_url}movements${query}`,this.headers).then((res)=>{
                this.lista = res.data.data.data;
                this.actualizarTablaPaginada({columnas:this.columnas,lista:this.lista,total_paginas:res.data.data.last_page});
                this.actualizarLista({lista:this.lista,total_paginas:res.data.data.last_page});
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar Movimientos..");
            })
            //this.ocultarLoading();
        },
        detalle($event){
            console.log($event);
            this.$router.push({name:'movimientos_detalle',params:{id:$event.item.id}});
        },
        editar_movimiento($event){
            console.log($event);
            if($event.item.tipo_movimiento == "S"){
                this.$router.push({name:'editar_salida',params:{id:$event.item.id}});
            } else {
                this.$router.push({name:'movimientos_detalle',params:{id:$event.item.id}});
            }
        },
        crear(){
            let configuracion = {
                titulo_modal:'Crear Maxisaco',
                titulo_boton:'Crear',
                accion:'crear'
            }
            Event.$emit('abrir_modal_jumbo', null, configuracion);
        },
        async editar($event){
            console.log('editando',$event);
            this.configuracion_modal.titulo_modal = 'Editar Maxisaco';
            this.configuracion_modal.titulo_boton = 'Actualizar';
            this.configuracion_modal.accion = 'editar';
            Event.$emit('abrir_modal_jumbo',$event.item,this.configuracion_modal);
        },
        async download(movimiento){
            await this.axios.get(`${this.base_url}movimientos_a_excel/${movimiento.id}`, this.headers).then((res)=>{
                window.location.href = this.download_url.replace('bitacoras', 'movimientos') + res.data;
            }).catch((e)=>{
                console.log(e);
            })
        },
        ...mapMutations(['mostrarLoading','ocultarLoading','actualizarTablaPaginada','actualizarLista'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'download_url'])
    },
    components:{
        'tabla-paginada':TablaPaginada,
        'modal-ayuda':ModalAyudas
    }
}
</script>
<style scoped>
    .filitas > td{
        padding: 0.2em 1em;
        border-top: 1px solid #ccc;
    }
    .filitas { 
        border-spacing: 0;
        border-collapse:inherit ;
        border:1px solid #ccc;
    }
</style>